import Vue from 'vue';
import Vuex from 'vuex';
import Vuetify from 'vuetify';
import VueFire from 'vuefire';
import firebase from 'firebase';
import { sync } from 'vuex-router-sync';
import 'vuetify/dist/vuetify.min.css';
import 'firebase/firestore';
import App from './App';
import router from './router';
import store from './store';

Vue.use(Vuex);
Vue.use(Vuetify);
Vue.use(VueFire);
Vue.config.productionTip = false;
sync(store, router);

const config = {
  apiKey: 'AIzaSyBQ1Iqt1TVCcQ3VUj_JTfxN3ZBVkZa7fFk',
  authDomain: 'gambit-tracker.firebaseapp.com',
  databaseURL: 'https://gambit-tracker.firebaseio.com',
  projectId: 'gambit-tracker',
  storageBucket: 'gambit-tracker.appspot.com',
  messagingSenderId: '19083041002',
};

/* eslint-disable no-new */
const firebaseApp = firebase.initializeApp(config);
// eslint-disable-next-line
export const db = firebaseApp.firestore();
/* eslint-disable no-new */
new Vue({
  store,
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js